const app = require("../firebase-config");

function setLocalEmail(key, email) {
  localStorage.setItem(`${app.default.options.projectId}-${key}-email`, email);
}

function removeLocalEmail(key) {
  localStorage.removeItem(`${app.default.options.projectId}-${key}-email`);
}

export function getCurrentEmail(key) {
  return localStorage.getItem(`${app.default.options.projectId}-${key}-email`);
}

export function login(usersRef, selectorKey) {
  return function({
    email = "",
    company = "",
    building = "",
    subscribed = false,
    app = ""
  }) {
    const hash = btoa(email.toLowerCase());

    return usersRef
      .child(hash)
      .child("deleted")
      .once("value")
      .then(snap => snap.val())
      .then(isDeleted => {
        if (isDeleted) {
          removeLocalEmail(selectorKey);
          throw new Error("Access Denied");
        }

        setLocalEmail(selectorKey, email);

        console.log(hash, email, company, building);

        if (company || building) {
          usersRef.child(hash).update({
            email,
            email_me: subscribed,
            company,
            building,
            last_login: new Date()
          });
        } else {
          usersRef.child(hash).update({ last_login: new Date(), email });
        }
      });
  };
}

export const useDeal = (dealStatsRef, selector) => id => {
  console.log("Use Dea", new Date(), getCurrentEmail());
  dealStatsRef.child(id).push({
    email: getCurrentEmail(selector),
    datetime: new Date().getTime(),
    deal: id
  });
};



// WEBPACK FOOTER //
// ./src/user/actions.js